import { runInAction } from 'mobx'

import { timer } from 'utils'

import BaseStore from './BaseStore'

let state

export class Message extends BaseStore {
  constructor() {
    super()
    this.observable({
      message: null,
      seconds: 5,
    })

    state = this
  }

  error({ title, message, seconds }) {
    const data = {
      type: 'error',
      title,
      message,
      created_at: timer.get(),
    }

    this.createMessage(data, seconds)
  }

  success({ title, message, seconds }) {
    const data = {
      type: 'success',
      title,
      message,
      created_at: timer.get(),
    }

    this.createMessage(data, seconds)
  }

  createMessage(data, seconds = 5) {
    setTimeout(() => {
      state.clearMessage()
    }, 4000)

    runInAction(() => {
      state.message = data
      state.seconds = seconds
    })
  }

  clearMessage() {
    const { message, seconds } = this.toJS()
    const now = timer.get()
    if (message) {
      const val = now.diff(message.created_at, 'seconds')
      if (val > seconds) {
        runInAction(() => {
          state.message = null
        })
      } else {
        setTimeout(() => {
          state.clearMessage()
        }, 4000)
      }
    }
  }
}

export default new Message()
